

// import React, { useState } from 'react';
// import { Formik, Form, Field } from 'formik';
// import * as Yup from 'yup';
// import {
//   Box,
//   useTheme,
//   Typography,
//   TextField,
//   Select,
//   MenuItem,
//   Button,
//   FormControl,
//   InputLabel,
//   Snackbar,
//   Alert,
//   Grid,
//   Divider,
//   Chip,
// } from '@mui/material';
// import CancelIcon from '@mui/icons-material/Cancel';
// import Header from '../../components/Header';
// import { tokens } from '../../theme';
// import { useAuth } from '../../AuthContext';

// // Validation schemas
// const intervalSchema = Yup.object().shape({
//   dataFetchInterval: Yup.number()
//     .positive('Interval must be positive')
//     .required('Data fetch interval is required')
//     .when('dataFetchUnit', {
//       is: 'seconds',
//       then: Yup.number().min(1, 'Must be at least 1 second').max(3600, 'Must be at most 3600 seconds'),
//       otherwise: Yup.number().min(1, 'Must be at least 1 minute').max(60, 'Must be at most 60 minutes'),
//     }),
//   dataFetchUnit: Yup.string().oneOf(['seconds', 'minutes'], 'Invalid unit').required('Unit is required'),
//   healthCheckInterval: Yup.number()
//     .positive('Interval must be positive')
//     .required('Health check interval is required')
//     .when('healthCheckUnit', {
//       is: 'seconds',
//       then: Yup.number().min(1, 'Must be at least 1 second').max(3600, 'Must be at most 3600 seconds'),
//       otherwise: Yup.number().min(1, 'Must be at least 1 minute').max(60, 'Must be at most 60 minutes'),
//     }),
//   healthCheckUnit: Yup.string().oneOf(['seconds', 'minutes'], 'Invalid unit').required('Unit is required'),
//   imei_list: Yup.array()
//     .min(1, 'At least one pump must be selected')
//     .required('Pump selection is required'),
// });

// const firmwareSchema = Yup.object().shape({
//   firmwareFile: Yup.mixed()
//     .required('Firmware file is required')
//     .test('fileType', 'File must be a .hex file', (value) => value && value.name.endsWith('.hex'))
//     .test('fileSize', 'File size must be less than 10MB', (value) => value && value.size <= 10 * 1024 * 1024),
//   version: Yup.string().required('Version number is required'),
//   fileSize: Yup.string().required('File size is required'),
//   imei_list: Yup.array()
//     .min(1, 'At least one pump must be selected')
//     .required('Pump selection is required'),
// });

// const PumpConfigUpdate = () => {
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);
//   const { updatePumpConfig, pumpsWithFirmware } = useAuth();
//   const [intervalSnackbar, setIntervalSnackbar] = useState({ open: false, message: '', severity: 'info' });
//   const [firmwareSnackbar, setFirmwareSnackbar] = useState({ open: false, message: '', severity: 'info' });
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [fileInfo, setFileInfo] = useState({ version: '', fileSize: '' });

//   const handleIntervalSnackbarClose = () => {
//     setIntervalSnackbar({ ...intervalSnackbar, open: false });
//   };

//   const handleFirmwareSnackbarClose = () => {
//     setFirmwareSnackbar({ ...firmwareSnackbar, open: false });
//   };

//   const handleIntervalSubmit = async (values, { setSubmitting, resetForm }) => {
//     try {
//       if (!pumpsWithImei?.length) {
//         throw new Error('No pumps available to configure');
//       }

//       // Convert intervals to seconds
//       const dataFetchInterval = values.dataFetchUnit === 'seconds'
//         ? values.dataFetchInterval
//         : values.dataFetchInterval * 60;
//       const healthCheckInterval = values.healthCheckUnit === 'seconds'
//         ? values.healthCheckInterval
//         : values.healthCheckInterval * 60;

//       // Prepare FormData
//       const formData = new FormData();
//       formData.append('dataFetchInterval', dataFetchInterval);
//       formData.append('healthCheckInterval', healthCheckInterval);
//       formData.append('imei_list', values.imei_list.join(','));

//       await updatePumpConfig(formData);
//       setIntervalSnackbar({
//         open: true,
//         message: 'Pump intervals updated successfully!',
//         severity: 'success',
//       });
//       resetForm();
//     } catch (error) {
//       setIntervalSnackbar({
//         open: true,
//         message: error.message || 'Failed to update intervals',
//         severity: 'error',
//       });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleFirmwareSubmit = async (values, { setSubmitting, resetForm }) => {
//     try {
//       if (!pumpsWithImei?.length) {
//         throw new Error('No pumps available to configure');
//       }

//       // Prepare FormData
//       const formData = new FormData();
//       formData.append('firmwareFile', selectedFile);
//       formData.append('version', values.version);
//       formData.append('fileSize', values.fileSize);
//       formData.append('imei_list', values.imei_list.join(','));

//       await updatePumpConfig(formData);
//       setFirmwareSnackbar({
//         open: true,
//         message: 'Firmware updated successfully!',
//         severity: 'success',
//       });
//       // Don't reset the file selection, only reset the form fields
//       resetForm({
//         values: {
//           ...values,
//           // version: '',
//           // fileSize: '',
//           imei_list: [],
//         }
//       });
//     } catch (error) {
//       setFirmwareSnackbar({
//         open: true,
//         message: error.message || 'Failed to update firmware',
//         severity: 'error',
//       });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleFileChange = (event, setFieldValue) => {
//     const file = event.target.files[0];
//     if (file) {
//       setSelectedFile(file);
//       setFieldValue('fileSize', `${(file.size / (1024 * 1024)).toFixed(2)} MB`);
//     }
//   };

//   const handlePumpSelection = (event, setFieldValue, currentValues) => {
//     const value = event.target.value;
//     if (value.includes('select-all')) {
//       setFieldValue('imei_list', pumpsWithImei.map((pump) => pump.imei));
//     } else if (value.includes('deselect-all')) {
//       setFieldValue('imei_list', []);
//     } else {
//       setFieldValue('imei_list', value.filter((v) => v !== 'select-all' && v !== 'deselect-all'));
//     }
//   };

//   const PumpSelectionField = ({ values, errors, touched, setFieldValue, pumps }) => (
//     <FormControl fullWidth margin="normal" error={touched.imei_list && !!errors.imei_list}>
//       <InputLabel
//         shrink
//         sx={{
//           fontSize: '1.2rem',
//           '&.Mui-focused': {
//             fontSize: '1.2rem',
//             color: colors.blueAccent[500],
//           },
//           color: colors.grey[300],
//           marginTop: '-10px'
//         }}
//       >
//         Select Pumps (IMEI)
//       </InputLabel>
//       <Field
//         as={Select}
//         multiple
//         name="imei_list"
//         value={values.imei_list || []}
//         onChange={(e) => handlePumpSelection(e, setFieldValue, values.imei_list)}
//         renderValue={(selected) => (
//           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//             {selected.map((imei) => (
//               <Chip
//                 key={imei}
//                 label={
//                   pumps.find((pump) => pump.imei === imei)?.name
//                     ? `${imei} - ${pumps.find((pump) => pump.imei === imei).name}`
//                     : imei
//                 }
//                 onDelete={(e) => {
//                   e.stopPropagation();
//                   setFieldValue(
//                     'imei_list',
//                     selected.filter((v) => v !== imei)
//                   );
//                 }}
//                 deleteIcon={<CancelIcon onMouseDown={(event) => event.stopPropagation()} />}
//                 sx={{ backgroundColor: colors.grey[700], color: colors.grey[100] }}
//               />
//             ))}
//           </Box>
//         )}
//         MenuProps={{
//           PaperProps: {
//             style: {
//               maxHeight: 300,
//               backgroundColor: colors.primary[400],
//             },
//           },
//         }}
//         sx={{
//           backgroundColor: colors.primary[400],
//           '& .MuiSelect-select': {
//             color: colors.grey[100],
//           },
//           '& .MuiOutlinedInput-notchedOutline': {
//             borderColor: colors.grey[700],
//           },
//           '&:hover .MuiOutlinedInput-notchedOutline': {
//             borderColor: colors.blueAccent[300],
//           },
//         }}
//       >
//         <MenuItem value="select-all">Select All Pumps</MenuItem>
//         <MenuItem value="deselect-all">Deselect All Pumps</MenuItem>
//         {pumps.map((pump) => (
//           <MenuItem key={pump.imei} value={pump.imei}>
//             {pump.imei} - {pump.name || 'Unnamed Pump'}
//           </MenuItem>
//         ))}
//       </Field>
//       {touched.imei_list && errors.imei_list && (
//         <Typography color="error" variant="caption" sx={{ mt: 1 }}>
//           {errors.imei_list}
//         </Typography>
//       )}
//     </FormControl>
//   );

//   return (
//     <Box m="20px">
//       <Header title="Pump Configuration" subtitle="Update Configuration for Pumps" />
//       <Grid container spacing={3}>
//         {/* Intervals Form */}
//         <Grid item xs={12} md={6}>
//           <Box bgcolor={colors.primary[400]} p={3} borderRadius={2} boxShadow={3}>
//             <Typography variant="h5" color={colors.greenAccent[500]} mb={2}>
//               Update Intervals
//             </Typography>
//             <Formik
//               initialValues={{
//                 dataFetchInterval: '',
//                 dataFetchUnit: 'seconds',
//                 healthCheckInterval: '',
//                 healthCheckUnit: 'seconds',
//                 imei_list: [],
//               }}
//               validationSchema={intervalSchema}
//               onSubmit={handleIntervalSubmit}
//             >
//               {({ errors, touched, setFieldValue, isSubmitting, values }) => (
//                 <Form>
//                   <Box display="flex" flexDirection="column" gap={2}>
//                     {/* Pump Selection */}
//                     <PumpSelectionField
//                       values={values}
//                       errors={errors}
//                       touched={touched}
//                       setFieldValue={setFieldValue}
//                       pumps={pumpsWithImei}
//                     />

//                     {/* Data Fetch Interval */}
//                     <Box display="flex" gap={2} alignItems="flex-start">
//                       <FormControl fullWidth error={touched.dataFetchInterval && !!errors.dataFetchInterval}>
//                         <Field
//                           as={TextField}
//                           name="dataFetchInterval"
//                           label="Data Fetch Interval"
//                           type="number"
//                           variant="outlined"
//                           InputLabelProps={{ shrink: true }}
//                           error={touched.dataFetchInterval && !!errors.dataFetchInterval}
//                           helperText={touched.dataFetchInterval && errors.dataFetchInterval}
//                           sx={{
//                             '& .MuiInputBase-input': { color: colors.grey[100] },
//                             '& .MuiInputLabel-root': { color: colors.grey[300] },
//                             '& .MuiOutlinedInput-notchedOutline': { borderColor: colors.grey[700] },
//                           }}
//                         />
//                       </FormControl>
//                       <FormControl sx={{ minWidth: 120 }} error={touched.dataFetchUnit && !!errors.dataFetchUnit}>
//                         <InputLabel shrink sx={{ color: colors.grey[300] }}>
//                           Unit
//                         </InputLabel>
//                         <Field
//                           as={Select}
//                           name="dataFetchUnit"
//                           label="Unit"
//                           notched
//                           onChange={(e) => setFieldValue('dataFetchUnit', e.target.value)}
//                           sx={{
//                             '& .MuiSelect-select': { color: colors.grey[100] },
//                             '& .MuiOutlinedInput-notchedOutline': { borderColor: colors.grey[700] },
//                           }}
//                         >
//                           <MenuItem value="seconds">Seconds</MenuItem>
//                           <MenuItem value="minutes">Minutes</MenuItem>
//                         </Field>
//                         {touched.dataFetchUnit && errors.dataFetchUnit && (
//                           <Typography color="error" variant="caption">
//                             {errors.dataFetchUnit}
//                           </Typography>
//                         )}
//                       </FormControl>
//                     </Box>

//                     {/* Health Check Interval */}
//                     <Box display="flex" gap={2} alignItems="flex-start">
//                       <FormControl fullWidth error={touched.healthCheckInterval && !!errors.healthCheckInterval}>
//                         <Field
//                           as={TextField}
//                           name="healthCheckInterval"
//                           label="Health Check Interval"
//                           type="number"
//                           variant="outlined"
//                           InputLabelProps={{ shrink: true }}
//                           error={touched.healthCheckInterval && !!errors.healthCheckInterval}
//                           helperText={touched.healthCheckInterval && errors.healthCheckInterval}
//                           sx={{
//                             '& .MuiInputBase-input': { color: colors.grey[100] },
//                             '& .MuiInputLabel-root': { color: colors.grey[300] },
//                             '& .MuiOutlinedInput-notchedOutline': { borderColor: colors.grey[700] },
//                           }}
//                         />
//                       </FormControl>
//                       <FormControl sx={{ minWidth: 120 }} error={touched.healthCheckUnit && !!errors.healthCheckUnit}>
//                         <InputLabel shrink sx={{ color: colors.grey[300] }}>
//                           Unit
//                         </InputLabel>
//                         <Field
//                           as={Select}
//                           name="healthCheckUnit"
//                           label="Unit"
//                           notched
//                           onChange={(e) => setFieldValue('healthCheckUnit', e.target.value)}
//                           sx={{
//                             '& .MuiSelect-select': { color: colors.grey[100] },
//                             '& .MuiOutlinedInput-notchedOutline': { borderColor: colors.grey[700] },
//                           }}
//                         >
//                           <MenuItem value="seconds">Seconds</MenuItem>
//                           <MenuItem value="minutes">Minutes</MenuItem>
//                         </Field>
//                         {touched.healthCheckUnit && errors.healthCheckUnit && (
//                           <Typography color="error" variant="caption">
//                             {errors.healthCheckUnit}
//                           </Typography>
//                         )}
//                       </FormControl>
//                     </Box>

//                     {/* Submit Button */}
//                     <Button
//                       type="submit"
//                       variant="contained"
//                       disabled={isSubmitting}
//                       sx={{
//                         backgroundColor: colors.blueAccent[700],
//                         color: colors.grey[100],
//                         fontSize: '14px',
//                         fontWeight: 'bold',
//                         padding: '10px 20px',
//                         '&:hover': {
//                           backgroundColor: colors.blueAccent[800],
//                         },
//                       }}
//                     >
//                       {isSubmitting ? 'Updating Intervals...' : 'Update Intervals'}
//                     </Button>
//                   </Box>
//                 </Form>
//               )}
//             </Formik>
//           </Box>
//         </Grid>

//         {/* Firmware Form */}
//         <Grid item xs={12} md={6}>
//           <Box bgcolor={colors.primary[400]} p={3} borderRadius={2} boxShadow={3}>
//             <Typography variant="h5" color={colors.greenAccent[500]} mb={2}>
//               Update Firmware
//             </Typography>
//             <Formik
//               initialValues={{
//                 version: '',
//                 fileSize: '',
//                 imei_list: [],
//               }}
//               validationSchema={firmwareSchema}
//               onSubmit={handleFirmwareSubmit}
//             >
//               {({ errors, touched, setFieldValue, isSubmitting, values }) => (
//                 <Form>
//                   <Box display="flex" flexDirection="column" gap={2}>
//                     {/* File Upload Section */}
//                     <Box>
//                       <Typography variant="body1" mb={1} color={colors.grey[100]}>
//                         Firmware Update (.hex file)
//                       </Typography>
//                       <input
//                         type="file"
//                         accept=".hex"
//                         onChange={(e) => handleFileChange(e, setFieldValue)}
//                         style={{ color: colors.grey[100], marginBottom: '16px' }}
//                       />
//                       {selectedFile && (
//                         <Box mb={2}>
//                           <Typography variant="body2" color={colors.grey[100]}>
//                             Selected file: {selectedFile.name}
//                           </Typography>
//                         </Box>
//                       )}
//                     </Box>

//                     {/* Version Number */}
//                     <Field
//                       as={TextField}
//                       name="version"
//                       label="Version Number"
//                       variant="outlined"
//                       fullWidth
//                       InputLabelProps={{ shrink: true }}
//                       error={touched.version && !!errors.version}
//                       helperText={touched.version && errors.version}
//                       sx={{
//                         '& .MuiInputBase-input': { color: colors.grey[100] },
//                         '& .MuiInputLabel-root': { color: colors.grey[300] },
//                         '& .MuiOutlinedInput-notchedOutline': { borderColor: colors.grey[700] },
//                       }}
//                     />

//                     {/* File Size */}
//                     <Field
//                       as={TextField}
//                       name="fileSize"
//                       label="File Size"
//                       variant="outlined"
//                       fullWidth
//                       InputLabelProps={{ shrink: true }}
//                       error={touched.fileSize && !!errors.fileSize}
//                       helperText={touched.fileSize && errors.fileSize}
//                       sx={{
//                         '& .MuiInputBase-input': { color: colors.grey[100] },
//                         '& .MuiInputLabel-root': { color: colors.grey[300] },
//                         '& .MuiOutlinedInput-notchedOutline': { borderColor: colors.grey[700] },
//                       }}
//                     />

//                     {/* Pump Selection */}
//                     <PumpSelectionField
//                       values={values}
//                       errors={errors}
//                       touched={touched}
//                       setFieldValue={setFieldValue}
//                       pumps={pumpsWithImei}
//                     />

//                     {/* Submit Button */}
//                     <Button
//                       type="submit"
//                       variant="contained"
//                       disabled={isSubmitting || !selectedFile}
//                       sx={{
//                         backgroundColor: colors.blueAccent[700],
//                         color: colors.grey[100],
//                         fontSize: '14px',
//                         fontWeight: 'bold',
//                         padding: '10px 20px',
//                         '&:hover': {
//                           backgroundColor: colors.blueAccent[800],
//                         },
//                       }}
//                     >
//                       {isSubmitting ? 'Updating Firmware...' : 'Update Firmware'}
//                     </Button>
//                   </Box>
//                 </Form>
//               )}
//             </Formik>
//           </Box>
//         </Grid>
//       </Grid>

//       {/* Snackbars */}
//       <Snackbar
//         open={intervalSnackbar.open}
//         autoHideDuration={6000}
//         onClose={handleIntervalSnackbarClose}
//         anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
//       >
//         <Alert onClose={handleIntervalSnackbarClose} severity={intervalSnackbar.severity} sx={{ width: '100%' }}>
//           {intervalSnackbar.message}
//         </Alert>
//       </Snackbar>
//       <Snackbar
//         open={firmwareSnackbar.open}
//         autoHideDuration={6000}
//         onClose={handleFirmwareSnackbarClose}
//         anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
//       >
//         <Alert onClose={handleFirmwareSnackbarClose} severity={firmwareSnackbar.severity} sx={{ width: '100%' }}>
//           {firmwareSnackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default PumpConfigUpdate;




// import React, { useState, useEffect } from 'react';
// import { Formik, Form, Field } from 'formik';
// import * as Yup from 'yup';
// import {
//   Box,
//   useTheme,
//   Typography,
//   Select,
//   MenuItem,
//   Button,
//   FormControl,
//   InputLabel,
//   Snackbar,
//   Alert,
//   Grid,
//   Chip,
// } from '@mui/material';
// import CancelIcon from '@mui/icons-material/Cancel';
// import Header from '../../components/Header';
// import { tokens } from '../../theme';
// import { useAuth } from '../../AuthContext';

// // Validation schema
// const firmwareSchema = Yup.object().shape({
//   version: Yup.string()
//     .required('Firmware version is required')
//     .oneOf(['1', '2', '3'], 'Invalid version'),
//   imei_list: Yup.array()
//     .min(1, 'At least one pump must be selected')
//     .required('Pump selection is required'),
// });

// const PumpConfigUpdate = () => {
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);
//   const { authorizedFetch } = useAuth();
//   const [pumpsWithFirmware, setPumpsWithFirmware] = useState([]);
//   const [availableVersions,setAvailableVersions]=useState([])
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

//   // Simulate fetching pumps (replace with actual API call)
//   useEffect(() => {
//     const fetchPumps = async () => {
//       try {
//         const versionResponse= await authorizedFetch('/config/firmware')
//         const newVersionResponse= await versionResponse.json();
//         setAvailableVersions(newVersionResponse.map((item)=>item.version))
//         const response= await authorizedFetch('/pump/firmware')
//         const pumpWithFirmwareResponse= await response.json();
//         // Mock API response with provided JSON
//         // const response = [
//         //   { imei: '001', name: 'servotech_testing_pump_2', updated: true, version: 'base' },
//         //   { imei: '860953067393685', name: 'servotech_mqtt_pump_test', updated: true, version: 'base' },
//         //   { imei: '867808063673709', name: 'solar testing pump', updated: true, version: 'base' },
//         // ];
//         setPumpsWithFirmware(pumpWithFirmwareResponse.filter((pump)=>(pump.updated===true&&(pump.version==='base'||pump.version<)));
//         // Uncomment for actual API call:
//         // const response = await authorizedFetch('/pumps');
//         // setpumpsWithFirmware(await response.json());
//       } catch (error) {
//         setSnackbar({
//           open: true,
//           message: 'Failed to fetch pumps',
//           severity: 'error',
//         });
//       }
//     };
//     fetchPumps();
//   }, [authorizedFetch]);

//   const handleSnackbarClose = () => {
//     setSnackbar({ ...snackbar, open: false });
//   };

//   const handleSubmit = async (values, { setSubmitting, resetForm }) => {
//     try {
//       if (!pumpsWithFirmware?.length) {
//         throw new Error('No pumps available to update');
//       }

//       // Prepare FormData
//       const formData = new FormData();
//       formData.append('imei_list', values.imei_list.join(','));
//       formData.append('version', values.version);
// console.log('this is the formdata that will be sent',{imei_list:[values.imei_list.join(',')],version:Number(values.version[0])})
//       // API call
//       const bodyObject={imei_list:[values.imei_list.join(',')],version:Number(values.version[0])}
//       const response = await authorizedFetch('/pump/firmware', {
//         method: 'POST',
//         body: JSON.stringify(bodyObject),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || 'Failed to update firmware');
//       }

//       setSnackbar({
//         open: true,
//         message: 'Firmware update initiated successfully!',
//         severity: 'success',
//       });
//       resetForm();
//     } catch (error) {
//       setSnackbar({
//         open: true,
//         message: error.message || 'Failed to update firmware',
//         severity: 'error',
//       });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handlePumpSelection = (event, setFieldValue, currentValues) => {
//     const value = event.target.value;
//     if (value.includes('select-all')) {
//       setFieldValue('imei_list', pumpsWithFirmware.map((pump) => pump.imei));
//     } else if (value.includes('deselect-all')) {
//       setFieldValue('imei_list', []);
//     } else {
//       setFieldValue('imei_list', value.filter((v) => v !== 'select-all' && v !== 'deselect-all'));
//     }
//   };

//   const PumpSelectionField = ({ values, errors, touched, setFieldValue, pumps }) => (
//     <FormControl fullWidth margin="normal" error={touched.imei_list && !!errors.imei_list}>
//       <InputLabel
//         shrink
//         sx={{
//           fontSize: '1.2rem',
//           '&.Mui-focused': {
//             fontSize: '1.2rem',
           
//             color: colors.blueAccent[500],
            
//           },
//           marginTop:'-10px',
//           marginLeft:'-10px',
//           color: colors.grey[300],
//         }}
//       >
//         Select Pumps (IMEI)
//       </InputLabel>
//       {values.imei_list?.length > 0 ? (
//         <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1, mt: 2 }}>
//           {values.imei_list.map((imei) => {
//             const pump = pumps.find((p) => p.imei === imei);
//             return (
//               <Chip
//                 key={imei}
//                 label={
//                   pump
//                     ? `${imei} - ${pump.name || 'Unnamed Pump'} - ${
//                         pump.updated ? `v-${pump.version}` : 'Update in Progress'
//                       }`
//                     : imei
//                 }
//                 onDelete={() =>
//                   setFieldValue(
//                     'imei_list',
//                     values.imei_list.filter((v) => v !== imei)
//                   )
//                 }
//                 deleteIcon={<CancelIcon />}
//                 sx={{ maxWidth: '80%', backgroundColor: colors.grey[700], color: colors.grey[100] }}
//               />
//             );
//           })}
//         </Box>
//       ) : (
//         <Field
//           as={Select}
//           multiple
//           name="imei_list"
//           value={values.imei_list || []}
//           onChange={(e) => handlePumpSelection(e, setFieldValue, values.imei_list)}
//           renderValue={(selected) => (
//             <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//               {selected.map((imei) => {
//                 const pump = pumps.find((p) => p.imei === imei);
//                 return (
//                   <Chip
//                     key={imei}
//                     label={
//                       pump
//                         ? `${imei} - ${pump.name || 'Unnamed Pump'} - ${
//                             pump.updated ? `v${pump.version}` : 'Update in Progress'
//                           }`
//                         : imei
//                     }
//                     onDelete={() =>
//                       setFieldValue(
//                         'imei_list',
//                         selected.filter((v) => v !== imei)
//                       )
//                     }
//                     deleteIcon={<CancelIcon onMouseDown={(event) => event.stopPropagation()} />}
//                     sx={{ backgroundColor: colors.grey[700], color: colors.grey[100] }}
//                   />
//                 );
//               })}
//             </Box>
//           )}
//           MenuProps={{
//             PaperProps: {
//               style: {
//                 maxHeight: 300,
//                 backgroundColor: colors.primary[400],
//               },
//             },
//           }}
//           sx={{
//             backgroundColor: colors.primary[400],
//             '& .MuiSelect-select': {
//               color: colors.grey[100],
//             },
//             '& .MuiOutlinedInput-notchedOutline': {
//               borderColor: colors.grey[700],
//             },
//             '&:hover .MuiOutlinedInput-notchedOutline': {
//               borderColor: colors.blueAccent[300],
//             },
//           }}
//         >
//           <MenuItem value="select-all">Select All Pumps</MenuItem>
//           <MenuItem value="deselect-all">Deselect All Pumps</MenuItem>
//           {pumps.map((pump) => (
//             <MenuItem key={pump.imei} value={pump.imei}>
//               {pump.imei} - {pump.name || 'Unnamed Pump'} -{' '}
//               {pump.updated ? `v${pump.version}` : 'Update in Progress'}
//             </MenuItem>
//           ))}
//         </Field>
//       )}
//       {touched.imei_list && errors.imei_list && (
//         <Typography color="error" variant="caption" sx={{ mt: 1 }}>
//           {errors.imei_list}
//         </Typography>
//       )}
//     </FormControl>
//   );

//   return (
//     <Box m="20px">
//       <Header title="Pump Firmware Update" subtitle="Update Firmware for Selected Pumps" />
//       <Grid container spacing={3} justifyContent="center">
//         <Grid item xs={12} md={6}>
//           <Box bgcolor={colors.primary[400]} p={3} borderRadius={2} boxShadow={3}>
//             <Typography variant="h5" color={colors.greenAccent[500]} mb={2}>
//               Update Firmware
//             </Typography>
//             <Formik
//               initialValues={{
//                 version: '',
//                 imei_list: [],
//               }}
//               validationSchema={firmwareSchema}
//               onSubmit={handleSubmit}
//             >
//               {({ errors, touched, setFieldValue, isSubmitting, values }) => (
//                 <Form>
//                   <Box display="flex" flexDirection="column" gap={2}>
//                     {/* Version Selection */}
//                     <FormControl fullWidth margin="normal" error={touched.version && !!errors.version}>
//                       <InputLabel
//                         shrink
//                         sx={{
//                           fontSize: '1.2rem',
//                           '&.Mui-focused': {
//                             fontSize: '1.2rem',
//                             color: colors.blueAccent[500],
//                           },
                          
//                           color: colors.grey[300],
//                         }}
//                       >
//                         Firmware Version
//                       </InputLabel>
//                       <Field
//                         as={Select}
//                         name="version"
//                         label="Firmware Version"
//                         notched
//                         sx={{
//                           backgroundColor: colors.primary[400],
//                           '& .MuiSelect-select': {
//                             color: colors.grey[100],
//                           },
//                           '& .MuiOutlinedInput-notchedOutline': {
//                             borderColor: colors.grey[700],
//                           },
//                           '&:hover .MuiOutlinedInput-notchedOutline': {
//                             borderColor: colors.blueAccent[300],
//                           },
//                         }}
//                       >
//                         <MenuItem value="" disabled>
//                           Select a version
//                         </MenuItem>
//                         {availableVersions.map((version) => (
//                           <MenuItem key={version} value={version}>
//                             Version {version}
//                           </MenuItem>
//                         ))}
//                       </Field>
//                       {touched.version && errors.version && (
//                         <Typography color="error" variant="caption" sx={{ mt: 1 }}>
//                           {errors.version}
//                         </Typography>
//                       )}
//                     </FormControl>

//                     {/* Pump Selection */}
//                     <PumpSelectionField
//                       values={values}
//                       errors={errors}
//                       touched={touched}
//                       setFieldValue={setFieldValue}
//                       pumps={pumpsWithFirmware}
//                     />

//                     {/* Submit Button */}
//                     <Button
//                       type="submit"
//                       variant="contained"
//                       disabled={isSubmitting}
//                       sx={{
//                         backgroundColor: colors.blueAccent[700],
//                         color: colors.grey[100],
//                         fontSize: '14px',
//                         fontWeight: 'bold',
//                         padding: '10px 20px',
//                         '&:hover': {
//                           backgroundColor: colors.blueAccent[800],
//                         },
//                       }}
//                     >
//                       {isSubmitting ? 'Updating Firmware...' : 'Update Firmware'}
//                     </Button>
//                   </Box>
//                 </Form>
//               )}
//             </Formik>
//           </Box>
//         </Grid>
//       </Grid>

//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={handleSnackbarClose}
//         anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
//       >
//         <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default PumpConfigUpdate;






import React, { useState, useEffect } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import {
  Box,
  useTheme,
  Typography,
  Select,
  MenuItem,
  Button,
  FormControl,
  InputLabel,
  Snackbar,
  Alert,
  Grid,
  Chip,
} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import Header from '../../components/Header';
import { tokens } from '../../theme';
import { useAuth } from '../../AuthContext';

// Parse version for comparison
const parseVersion = (version) => {
  if (!version || version === 'base') return 0;
  return parseInt(version, 10) || 0;
};

// Validation schema
const firmwareSchema = Yup.object().shape({
  version: Yup.string()
    .required('Firmware version is required')
    .test('valid-version', 'Invalid version', (value) => value && !isNaN(parseVersion(value))),
  imei_list: Yup.array()
    .min(1, 'At least one pump must be selected')
    .required('Pump selection is required')
    // .test('eligible-pumps', 'Selected pumps must be eligible for update', function (value) {
    //   const eligiblePumps = this.options.context.eligiblePumps || [];
    //   return value.every((imei) => eligiblePumps.some((pump) => pump.imei === imei));
    // }),
});

const PumpConfigUpdate = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { authorizedFetch } = useAuth();
  const [pumpsWithFirmware, setPumpsWithFirmware] = useState([]);
  const [availableVersions, setAvailableVersions] = useState([]);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

  // Fetch pumps and versions
  useEffect(() => {
    const fetchData = async () => {
      try {
        const versionResponse = await authorizedFetch('/config/firmware');
        if (!versionResponse.ok) {
          throw new Error('Failed to fetch firmware versions');
        }
        const versions = await versionResponse.json();

        setAvailableVersions(versions.map((item) => String(item.version)).sort((a, b) => parseVersion(a) - parseVersion(b)));


        const pumpResponse = await authorizedFetch('/pump/firmware');
        if (!pumpResponse.ok) {
          throw new Error('Failed to fetch pumps');
        }
        const pumps = await pumpResponse.json();
        setPumpsWithFirmware(pumps);
      } catch (error) {
        setSnackbar({
          open: true,
          message: error.message || 'Failed to fetch data',
          severity: 'error',
        });
      }
    };
    fetchData();
  }, [authorizedFetch]);

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      if (!pumpsWithFirmware?.length) {
        throw new Error('No pumps available to update');
      }

      // Validate eligible pumps
      const eligiblePumps = pumpsWithFirmware.filter(
        (pump) => pump.updated && parseVersion(pump.version) < parseVersion(values.version)
      );
      if (!eligiblePumps.length) {
        throw new Error('No pumps are eligible for the selected firmware version');
      }
      if (!values.imei_list.every((imei) => eligiblePumps.some((pump) => pump.imei === imei))) {
        throw new Error('Some selected pumps are not eligible for update');
      }

      // Prepare JSON payload
      const payload = {
        imei_list: values.imei_list,
        version: parseVersion(values.version),
      };

      // API call
      const response = await authorizedFetch('/pump/firmware', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to update firmware');
      }

      setSnackbar({
        open: true,
        message: 'Firmware update initiated successfully!',
        severity: 'success',
      });
      resetForm();
    } catch (error) {
      setSnackbar({
        open: true,
        message: error.message || 'Failed to update firmware',
        severity: 'error',
      });
    } finally {
      setSubmitting(false);
    }
  };

  const handlePumpSelection = (event, setFieldValue, selectedVersion) => {
    const value = event.target.value; // Array of selected values
    const eligiblePumps = pumpsWithFirmware.filter(
      (pump) => pump.updated && parseVersion(pump.version) < parseVersion(selectedVersion)
    );

    if (value.includes('select-all')) {
      setFieldValue('imei_list', eligiblePumps.map((pump) => pump.imei));
    } else if (value.includes('deselect-all')) {
      setFieldValue('imei_list', []);
    } else {
      const selected = Array.isArray(value) ? value : [value];
      const ineligibleSelection = selected.find(
        (imei) => !eligiblePumps.some((pump) => pump.imei === imei)
      );
      if (ineligibleSelection) {
        const pump = pumpsWithFirmware.find((p) => p.imei === ineligibleSelection);
        setSnackbar({
          open: true,
          message: pump.updated
            ? `Pump ${pump.imei} has version ${pump.version}, cannot update to ${selectedVersion}`
            : `Pump ${pump.imei} is currently updating, please try again later`,
          severity: 'warning',
        });
        return;
      }
      setFieldValue('imei_list', selected.filter((v) => v !== 'select-all' && v !== 'deselect-all'));
    }
  };

  const PumpSelectionField = ({ values, errors, touched, setFieldValue, pumps }) => {
    const eligiblePumps = values.version
      ? pumps.filter((pump) => pump.updated && parseVersion(pump.version) < parseVersion(values.version))
      : [];

    return (
      <FormControl fullWidth margin="normal" error={touched.imei_list && !!errors.imei_list}>
        <InputLabel
          shrink
          sx={{
            fontSize: '1.2rem',
            '&.Mui-focused': {
              fontSize: '1.2rem',
              color: colors.blueAccent[500],
            },
            marginTop: '-10px',
            marginLeft: '-10px',
            color: colors.grey[300],
          }}
        >
          Select Pumps (IMEI)
        </InputLabel>
        <Field
          as={Select}
          multiple
          name="imei_list"
          value={values.imei_list || []}
          onChange={(e) => handlePumpSelection(e, setFieldValue, values.version)}
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map((imei) => {
                const pump = pumps.find((p) => p.imei === imei);
                return (
                  <Chip
                    key={imei}
                    label={
                      pump
                        ? `${imei} - ${pump.name || 'Unnamed Pump'} - ${
                            pump.updated ? `v${pump.version}` : 'Update in Progress'
                          }`
                        : imei
                    }
                    onDelete={() =>
                      setFieldValue(
                        'imei_list',
                        values.imei_list.filter((v) => v !== imei)
                      )
                    }
                    deleteIcon={<CancelIcon onMouseDown={(event) => event.stopPropagation()} />}
                    sx={{ backgroundColor: colors.grey[700], color: colors.grey[100] }}
                  />
                );
              })}
            </Box>
          )}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 300,
                backgroundColor: colors.primary[400],
              },
            },
          }}
          sx={{
            backgroundColor: colors.primary[400],
            '& .MuiSelect-select': {
              color: colors.grey[100],
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: colors.grey[700],
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: colors.blueAccent[300],
            },
          }}
          disabled={!values.version}
        >
          <MenuItem value="select-all" disabled={eligiblePumps.length === 0}>
            Select All Pumps
          </MenuItem>
          <MenuItem value="deselect-all">Deselect All Pumps</MenuItem>
          {pumps.map((pump) => (
            <MenuItem
              key={pump.imei}
              value={pump.imei}
              disabled={!pump.updated || parseVersion(pump.version) >= parseVersion(values.version)}
              onClick={() => {
                if (!pump.updated) {
                  setSnackbar({
                    open: true,
                    message: `Pump ${pump.imei} is currently updating, please try again later`,
                    severity: 'warning',
                  });
                } else if (parseVersion(pump.version) >= parseVersion(values.version)) {
                  setSnackbar({
                    open: true,
                    message: `Pump ${pump.imei} has version ${pump.version}, cannot update to ${values.version}`,
                    severity: 'warning',
                  });
                }
              }}
            >
              {pump.imei} - {pump.name || 'Unnamed Pump'} -{' '}
              {pump.updated ? `v${pump.version}` : 'Update in Progress'}
            </MenuItem>
          ))}
        </Field>
        {touched.imei_list && errors.imei_list && (
          <Typography color="error" variant="caption" sx={{ mt: 1 }}>
            {errors.imei_list}
          </Typography>
        )}
        {!values.version && (
          <Typography color="warning" variant="caption" sx={{ mt: 1 }}>
            Please select a firmware version first
          </Typography>
        )}
        {values.version && eligiblePumps.length === 0 && (
          <Typography color="warning" variant="caption" sx={{ mt: 1 }}>
            No pumps are eligible for version {values.version}
          </Typography>
        )}
      </FormControl>
    );
  };

  return (
    <Box m="20px">
      <Header title="Pump Firmware Update" subtitle="Update Firmware for Selected Pumps" />
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12} md={6}>
          <Box bgcolor={colors.primary[400]} p={3} borderRadius={2} boxShadow={3}>
            <Typography variant="h5" color={colors.greenAccent[500]} mb={2}>
              Update Firmware
            </Typography>
            <Formik
              initialValues={{
                version: '',
                imei_list: [],
              }}
              validationSchema={firmwareSchema}
              onSubmit={handleSubmit}
            >
              {({ errors, touched, setFieldValue, isSubmitting, values, setFormikState }) => (
                <Form>
                  <Box display="flex" flexDirection="column" gap={2}>
                    {/* Version Selection */}
                    <FormControl fullWidth margin="normal" error={touched.version && !!errors.version}>
                      <InputLabel
                        shrink
                        sx={{
                          fontSize: '1.2rem',
                          '&.Mui-focused': {
                            fontSize: '1.2rem',
                            color: colors.blueAccent[500],
                          },
                          color: colors.grey[300],
                        }}
                      >
                        Firmware Version
                      </InputLabel>
                      <Field
                        as={Select}
                        name="version"
                        label="Firmware Version"
                        notched
                        onChange={(e) => {
                          setFieldValue('version', e.target.value);
                          // Clear imei_list if version changes
                          setFieldValue('imei_list', []);
                          // Update validation context
                          setFormikState((prev) => ({
                            ...prev,
                            validationContext: {
                              eligiblePumps: pumpsWithFirmware.filter(
                                (pump) => pump.updated && parseVersion(pump.version) < parseVersion(e.target.value)
                              ),
                            },
                          }));
                        }}
                        sx={{
                          backgroundColor: colors.primary[400],
                          '& .MuiSelect-select': {
                            color: colors.grey[100],
                          },
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: colors.grey[700],
                          },
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: colors.blueAccent[300],
                          },
                        }}
                      >
                        <MenuItem value="" disabled>
                          Select a version
                        </MenuItem>
                        {availableVersions.map((version) => (
                          <MenuItem key={version} value={version}>
                            Version {version}
                          </MenuItem>
                        ))}
                      </Field>
                      {touched.version && errors.version && (
                        <Typography color="error" variant="caption" sx={{ mt: 1 }}>
                          {errors.version}
                        </Typography>
                      )}
                    </FormControl>

                    {/* Pump Selection */}
                    <PumpSelectionField
                      values={values}
                      errors={errors}
                      touched={touched}
                      setFieldValue={setFieldValue}
                      pumps={pumpsWithFirmware}
                    />

                    {/* Submit Button */}
                    <Button
                      type="submit"
                      variant="contained"
                      disabled={
                        isSubmitting ||
                        !values.version ||
                        pumpsWithFirmware.filter(
                          (pump) => pump.updated && parseVersion(pump.version) < parseVersion(values.version)
                        ).length === 0
                      }
                      sx={{
                        backgroundColor: colors.blueAccent[700],
                        color: colors.grey[100],
                        fontSize: '14px',
                        fontWeight: 'bold',
                        padding: '10px 20px',
                        '&:hover': {
                          backgroundColor: colors.blueAccent[800],
                        },
                        '&.Mui-disabled': {
                          backgroundColor: colors.grey[700],
                          color: colors.grey[300],
                        },
                      }}
                    >
                      {isSubmitting ? 'Updating Firmware...' : 'Update Firmware'}
                    </Button>
                  </Box>
                </Form>
              )}
            </Formik>
          </Box>
        </Grid>
      </Grid>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default PumpConfigUpdate;
